document.addEventListener('DOMContentLoaded', function () {
  // 必要な要素が存在するか最初にチェック
  const container = document.querySelector('.engineeringservices-sec');
  if (!container) return; // 要素がない場合は処理を終了

  let isEventsBound = false;

  function bindEvents() {
    const textLinks = document.querySelectorAll('.engineeringservices-sec .text a');
    const figures = document.querySelectorAll('.engineeringservices-sec .photo figure');
    const defaultFigure = document.querySelector('.engineeringservices-sec .photo .img-0');

    // 必要な要素が全て存在するか確認
    if (!textLinks.length || !figures.length || !defaultFigure) return;

    // マウスが乗っていない時はデフォルト画像を表示
    function showDefaultImage() {
      figures.forEach(fig => fig.classList.remove('active'));
      defaultFigure.classList.add('active');
    }

    // イベントを解除する関数
    function removeEvents() {
      textLinks.forEach(link => {
        link.removeEventListener('mouseenter', handleMouseEnter);
        link.removeEventListener('mouseleave', handleMouseLeave);
      });
      showDefaultImage();
      isEventsBound = false;
    }

    // マウスエンターのハンドラー
    function handleMouseEnter(index) {
      return function () {
        figures.forEach(fig => fig.classList.remove('active'));
        const targetFigure = document.querySelector(`.engineeringservices-sec .photo .img-${index + 1}`);
        if (targetFigure) {
          targetFigure.classList.add('active');
        }
      };
    }

    // マウスリーブのハンドラー
    function handleMouseLeave() {
      showDefaultImage();
    }

    // イベントを設定する関数
    function addEvents() {
      if (!isEventsBound) {
        showDefaultImage();
        textLinks.forEach((link, index) => {
          link.addEventListener('mouseenter', handleMouseEnter(index));
          link.addEventListener('mouseleave', handleMouseLeave);
        });
        isEventsBound = true;
      }
    }

    // メディアクエリの監視
    const mediaQuery = window.matchMedia('(min-width: 769px)');

    // メディアクエリの変更を監視する関数
    function handleMediaQueryChange(e) {
      if (e.matches) {
        addEvents();
      } else {
        removeEvents();
      }
    }

    // 初期チェックとリスナーの設定
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addListener(handleMediaQueryChange);
  }

  bindEvents();
});
